<div class="row-replacement ">
    <mat-card appearance="outlined" class="form-group preneed-mat-card ">
        <mat-panel-title class="stepper-header-text stepper-header-text-bold">
            <div class="row-replacement ">
                {{ CardTitle}}
            </div>
        </mat-panel-title>
        <br />
        <mat-radio-group class="example-radio-group" [formControl]="Answer">
            <div class="row" *ngFor="let answer of Answers">
                <mat-radio-button class="example-radio-button question-card"  [value]="answer" (change)="RadioChange($event)">
                    {{answer}}
                </mat-radio-button>
            </div>
        </mat-radio-group>
    </mat-card>
</div> 